import { render, staticRenderFns } from "./DoubleElimination.vue?vue&type=template&id=50a2ffc8&scoped=true"
import script from "./DoubleElimination.vue?vue&type=script&lang=js"
export * from "./DoubleElimination.vue?vue&type=script&lang=js"
import style0 from "./DoubleElimination.vue?vue&type=style&index=0&id=50a2ffc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a2ffc8",
  null
  
)

export default component.exports